import { createRouter, createWebHistory } from 'vue-router'
import IndexView from '@/views/IndexView'

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutUs.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/Products.vue')
  },
  {
    path:'/showcase',
    name:'showcase',
    component: () => import('../views/ShowCase.vue')
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: () => import('../views/ContactUs.vue')
  },
  {
    path:'/products/mseries',
    name:'mseries',
    component: () => import('../views/Products/ProductMseries.vue')
  },
  {
    path: '/products/nseries',
    name: 'nseries',
    component: () => import('../views/Products/ProductNseries.vue')
  },
  {
    path:'/products/soft',
    name:'soft',
    component: () => import('../views/Products/ProductSoft.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/Service.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
